// fiscal-plan.component.ts (updated)
import { Component, TemplateRef } from '@angular/core';
import { ViewChild, ElementRef } from '@angular/core';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  CalendarModule,
  DateAdapter,
  CalendarView,
  CalendarUtils,
  CalendarA11y,
  CalendarDateFormatter,
  CalendarEventTitleFormatter,
} from 'angular-calendar';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { startOfDay } from 'date-fns';
import { CalendarMonthViewDay } from 'angular-calendar';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { EventDetailsDialogComponent } from '@app/event-details-dialog/event-details-dialog.component';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { CalendarComponent } from '@app/calendar-component/calendar-component.component';
import { FiscalEventInterface } from '@app/interface/fiscal-event';
import { FiscalEventApi } from '@app/services/fiscal-event-api.service';
import {
  PaginatedResponse,
  RecursiveInterface,
} from '@app/services/base-authenticated.service';
import { HttpClientModule } from '@angular/common/http';
import { ChangeDetectorRef } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgForm } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatExpansionModule } from '@angular/material/expansion'; // Add this import
import { BaseChartDirective } from 'ng2-charts'; // Add this import
import { ChartConfiguration, ChartData, ChartType } from 'chart.js';
import { ActivatedRoute, NavigationEnd } from '@angular/router';
import { BackHeaderComponent } from '@app/back-header/back-header.component';
import { Router } from '@angular/router';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { NewFiscalEventDialogComponent } from '@app/new-fiscal-event-dialog/new-fiscal-event-dialog.component';
import { OrganizationApi } from '@app/services/organization-api.service';
import { Organizations } from '@app/interface/organizations';
import { InvoiceApi } from '@app/services/invoice-api';
import { InvoiceInterface } from '@app/interface/invoice';
import {
  FiscalEventDetailData,
  FiscalEventDetailsComponent,
} from '@app/fiscal-event-details/fiscal-event-details.component';
import {
  MatBottomSheet,
  MatBottomSheetModule,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormControl } from '@angular/forms';
import { FiscalPlanHelpDialogComponent } from '@app/fiscal-plan-help-dialog/fiscal-plan-help-dialog.component';

@Component({
  selector: 'izy-fiscal-plan',
  imports: [
    CalendarModule,
    MatButtonModule,
    MatIconModule,
    CommonModule,
    MatCardModule,
    MatListModule,
    MatSnackBarModule,
    MatFormFieldModule,
    MatSelectModule,
    MatExpansionModule,
    BaseChartDirective,
    BackHeaderComponent,
    MatCheckboxModule,
    FormsModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatIconModule,
    MatChipsModule,
    MatDividerModule,
    MatTooltipModule,
  ],
  templateUrl: './fiscal-plan.component.html',
  styleUrl: './fiscal-plan.component.scss',
  providers: [
    MatSnackBar,
    FiscalEventApi,
    CalendarUtils,
    CalendarA11y,
    CalendarDateFormatter,
    CalendarEventTitleFormatter,
    { provide: DateAdapter, useFactory: adapterFactory },
  ],
})
export class FiscalPlanComponent {
  @ViewChild('dettaglioMensile') dettaglioMensileElement!: ElementRef;
  @ViewChild('amountInfoDialog') amountInfoDialog!: TemplateRef<any>;

  showDelay = new FormControl(500);
  hideDelay = new FormControl(1000);

  view: CalendarView = CalendarView.Month;
  viewDate: Date = new Date();
  nextThreeEvents: FiscalEventInterface[] = [];
  nextYearEvents: FiscalEventInterface[] = [];
  allEvents: FiscalEventInterface[] = []; // Store all events

  currentYear = new Date().getFullYear();
  nextYear = this.currentYear + 1;
  nextYearTotalAmountTasse: number = 0;
  nextYearTotalAmountContributi: number = 0;
  nextYearDynamicTotalAmountTasse: number = 0;
  nextYearDynamicTotalAmountContributi: number = 0;
  yearTaxIncidence: number = 0;
  yearContributiIncidence: number = 0;
  taxableAmount: number = 0;

  organization_data: Organizations | null = null;

  // Year selection
  selectedYear: number = this.currentYear;
  availableYears: number[] = [
    this.currentYear - 1,
    this.currentYear,
    this.currentYear + 1,
    this.currentYear + 2,
  ];

  // Months for display
  months: string[] = [
    'Gennaio',
    'Febbraio',
    'Marzo',
    'Aprile',
    'Maggio',
    'Giugno',
    'Luglio',
    'Agosto',
    'Settembre',
    'Ottobre',
    'Novembre',
    'Dicembre',
  ];

  PensionFundMap: Record<string, string> = {
    TC01: 'Cassa nazionale previdenza e assistenza avvocati e procuratori legali',
    TC02: 'Cassa previdenza dottori commercialisti',
    TC03: 'Cassa previdenza e assistenza geometri',
    TC04: 'Cassa nazionale previdenza e assistenza ingegneri e architetti liberi professionisti',
    TC05: 'Cassa nazionale del notariato',
    TC06: 'Cassa nazionale previdenza e assistenza ragionieri e periti commerciali',
    TC07: 'Ente nazionale assistenza agenti e rappresentanti di commercio (ENASARCO)',
    TC08: 'Ente nazionale previdenza e assistenza consulenti del lavoro (ENPACL)',
    TC09: 'Ente nazionale previdenza e assistenza medici (ENPAM)',
    TC10: 'Ente nazionale previdenza e assistenza farmacisti (ENPAF)',
    TC11: 'Ente nazionale previdenza e assistenza veterinari (ENPAV)',
    TC12: "Ente nazionale previdenza e assistenza impiegati dell'agricoltura (ENPAIA)",
    TC13: 'Fondo previdenza impiegati imprese di spedizione e agenzie marittime',
    TC14: 'Istituto nazionale previdenza giornalisti italiani (INPGI)',
    TC15: 'Opera nazionale assistenza orfani sanitari italiani (ONAOSI)',
    TC16: 'Cassa autonoma assistenza integrativa giornalisti italiani (CASAGIT)',
    TC17: 'Ente previdenza periti industriali e periti industriali laureati (EPPI)',
    TC18: 'Ente previdenza e assistenza pluricategoriale (EPAP)',
    TC19: 'Ente nazionale previdenza e assistenza biologi (ENPAB)',
    TC20: 'Ente nazionale previdenza e assistenza professione infermieristica (ENPAPI)',
    TC21: 'Ente nazionale previdenza e assistenza psicologi (ENPAP)',
    TC22: 'INPS',
  };

  getFundName(code: string | undefined): string {
    if (!code) return 'Cassa non specificata';

    // Return the mapped name, or the raw code if it's somehow not in the list
    return this.PensionFundMap[code] || code;
  }

  // Track expanded panels
  expandedPanels: boolean[] = new Array(12).fill(false);

  constructor(
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private invoiceService: InvoiceApi,
    private fiscalEventService: FiscalEventApi,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router,
    private organizationService: OrganizationApi,
    private eventSheet: MatBottomSheet,
  ) {}

  // Chart.js configuration
  public lineChartType: ChartType = 'line';
  public lineChartData: ChartConfiguration['data'] = {
    datasets: [],
    labels: [],
  };
  public lineChartOptions: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Importo (€)',
        },
      },
      x: {
        title: {
          display: true,
          text: 'Mesi',
        },
      },
    },
    plugins: {
      legend: {
        display: true,
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.dataset.label}: ${context.parsed.y} €`;
          },
        },
      },
    },
  };

  isLoading: boolean = false;

  ngOnInit() {
    this.loadEvents();
    this.getOrganization();

    // this.prepareChartData();
    this.cdr.detectChanges();

    this.taxableAmount = 0;
    this.bothTaxableComputationAndYearChange();

    this.cdr.detectChanges();
  }

  ngAfterViewInit() {
    // this.prepareChartData();
    this.cdr.detectChanges();
  }

  private getOrganization() {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    if (organization_id && !isNaN(organization_id)) {
      const filterParams = {
        organization_id: organization_id,
      };

      this.organizationService
        .getOrganization<Organizations>(organization_id, filterParams)
        .subscribe({
          next: (organization_data: Organizations) => {
            console.log('Organization:', organization_data);
            this.organization_data = organization_data;
            this.cdr.detectChanges();
          },
          error: (err: any) => {
            console.error('Error loading organization:', err);
            this.cdr.detectChanges();
          },
        });
    } else {
      console.error(
        'Could not extract valid organization ID from URL or route parameters',
      );
    }
  }

  // getAnnualTotal(year: number) {
  //   const organization_id = Number(
  //     this.route.snapshot.paramMap.get('organizationId'),
  //   );

  //   if (organization_id && !isNaN(organization_id)) {
  //     this.organizationService
  //       .getOrganizationTotalInvoiceAmount(organization_id, year)
  //       .subscribe({
  //         next: (totalAmount: number) => {
  //           console.log('Total annual amount:', totalAmount);
  //           // Store the value
  //           this.taxableAmount = totalAmount;
  //           this.cdr.detectChanges(); // Trigger UI update
  //         },
  //         error: (error) => {
  //           console.error('Error fetching total amount:', error);
  //         },
  //       });
  //   }
  // }

  // Helper function for proper rounding
  private roundToTwo(num: number): number {
    return Math.round((num + Number.EPSILON) * 100) / 100;
  }

  openNewFiscalEventDialog(): void {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    const dialogRef = this.dialog.open(NewFiscalEventDialogComponent, {
      width: '500px',
      data: { organizationId: organization_id }, // Pass the organization_id here
    });

    // Subscribe to the dialog result to refresh events when a new one is created
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'success') {
        // Reload events to include the newly created one
        this.loadEvents();
        this.showSuccessMessage('Evento fiscale creato con successo!');
      }
    });
  }

  private loadEvents() {
    const organization_id = this.route.snapshot.paramMap.get('organizationId');

    this.isLoading = true;

    // Handle the case where organization_id might be null
    if (!organization_id) {
      console.error('Organization ID not found in route');
      return;
    }

    const filterParams: any = {};
    filterParams.is_deleted = false; // hide deleted invoices

    // Load all events without filtering by type
    this.fiscalEventService
      .getEventList(organization_id, filterParams)
      .subscribe({
        next: (response: PaginatedResponse<FiscalEventInterface>) => {
          this.allEvents = response.results;

          // Get next 3 events by date
          this.nextThreeEvents = [...this.allEvents]
            .sort(
              (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
            )
            .slice(0, 2);

          // Calculate totals for next year
          this.calculateNextYearTotals();

          // Prepare chart data HERE after events are loaded
          this.prepareChartData();

          this.isLoading = false;
          this.cdr.detectChanges();
        },
        error: (err: any) => {
          console.error('Error loading events:', err);
          this.showErrorMessage('Errore durante il caricamento della pagina.');
          this.isLoading = false;
          this.cdr.detectChanges();
        },
      });
  }

  private prepareChartData(): void {
    const currentYear = new Date().getFullYear();
    const years = [currentYear, currentYear + 1];
    const months = Array.from({ length: 12 }, (_, i) => i);

    // Prepare labels (month names)
    this.lineChartData.labels = this.months;

    // Prepare datasets for each year
    this.lineChartData.datasets = years.map((year) => {
      const monthlyData = months.map((month) => {
        const monthEvents = this.allEvents.filter((event) => {
          const eventDate = new Date(event.date);
          return (
            eventDate.getFullYear() === year && eventDate.getMonth() === month
            // && (event.type as string) === 'TASSE' // Uncomment if you want to filter by type
          );
        });

        return monthEvents.reduce(
          (total, event) => total + (Number(event.amount) || 0),
          0,
        );
      });

      return {
        data: monthlyData,
        label: `Tasse ${year}`,
        borderColor: year === currentYear ? '#678cb6' : '#c3b1d7',
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        pointBackgroundColor: year === currentYear ? '#678cb6' : '#c3b1d7',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: year === currentYear ? '#678cb6' : '#c3b1d7',
        fill: false,
        tension: 0.4,
      };
    });

    // Trigger change detection
    this.cdr.detectChanges();
  }

  scrollToDettaglioMensile(): void {
    if (this.dettaglioMensileElement) {
      this.dettaglioMensileElement.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }
  }

  private roundToTwoDecimals(num: number) {
    return Math.round((num + Number.EPSILON) * 100) / 100;
  }

  private calculateNextYearTotals() {
    // Calculate TASSE total for next year
    const tasseEvents = this.allEvents.filter(
      (event) =>
        (event.type as string) === 'TASSE' &&
        new Date(event.date).getFullYear() === this.nextYear,
    );
    this.nextYearTotalAmountTasse = tasseEvents.reduce((total, event) => {
      return total + (Number(event.amount) || 0);
    }, 0);

    this.nextYearTotalAmountTasse = this.roundToTwoDecimals(
      this.nextYearTotalAmountTasse,
    );

    // Calculate CONTRIBUTI total for next year
    const contributiEvents = this.allEvents.filter(
      (event) =>
        (event.type as string) === 'CONTRIBUTI' &&
        new Date(event.date).getFullYear() === this.nextYear,
    );
    this.nextYearTotalAmountContributi = contributiEvents.reduce(
      (total, event) => {
        return total + (Number(event.amount) || 0);
      },
      0,
    );

    this.nextYearTotalAmountContributi = this.roundToTwoDecimals(
      this.nextYearTotalAmountContributi,
    );
  }

  // this function helps in computing the annual % incidence
  private calculateFollowingDynamicYearTotals(
    year: number = this.selectedYear,
  ) {
    // Calculate TASSE total for next year (dynamically)
    const tasseEvents = this.allEvents.filter(
      (event) =>
        (event.type as string) === 'TASSE' &&
        new Date(event.date).getFullYear() === year + 1, // compute following year
    );
    this.nextYearDynamicTotalAmountTasse = tasseEvents.reduce(
      (total, event) => {
        return total + (Number(event.amount) || 0);
      },
      0,
    );

    this.nextYearDynamicTotalAmountTasse = this.roundToTwoDecimals(
      this.nextYearDynamicTotalAmountTasse,
    );

    // Calculate CONTRIBUTI total for next year
    const contributiEvents = this.allEvents.filter(
      (event) =>
        (event.type as string) === 'CONTRIBUTI' &&
        new Date(event.date).getFullYear() === year + 1, // compute following year
    );
    this.nextYearDynamicTotalAmountContributi = contributiEvents.reduce(
      (total, event) => {
        return total + (Number(event.amount) || 0);
      },
      0,
    );

    this.nextYearDynamicTotalAmountContributi = this.roundToTwoDecimals(
      this.nextYearDynamicTotalAmountContributi,
    );
  }

  bothTaxableComputationAndYearChange(): void {
    console.log('selectedYear', this.selectedYear);

    // First get the taxable amount from API
    this.getAnnualTotal(this.selectedYear);
    // Note: onYearChange will be called after taxableAmount is received
  }

  // Update getAnnualTotal method
  getAnnualTotal(year: number) {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    if (organization_id && !isNaN(organization_id)) {
      this.organizationService
        .getOrganizationTotalInvoiceAmount(organization_id, year)
        .subscribe({
          next: (totalAmount: number) => {
            // console.log('Total annual amount:', totalAmount);
            // Store the value
            this.taxableAmount = totalAmount || 0; // Ensure it's never undefined

            // Now that we have taxableAmount, calculate following year totals and incidence
            this.calculateFollowingDynamicYearTotals(this.selectedYear);
            this.calculateIncidence();

            this.cdr.detectChanges(); // Trigger UI update
          },
          error: (error) => {
            console.error('Error fetching total amount:', error);
            this.taxableAmount = 0; // Set to 0 on error
            this.calculateFollowingDynamicYearTotals(this.selectedYear);
            this.calculateIncidence();
            this.cdr.detectChanges();
          },
        });
    }
  }

  handleAmountInfoClick(event: Event): void {
    // These two lines prevent the click from bubbling up and triggering anything else
    event.preventDefault();
    event.stopPropagation();

    // Open the simple info dialog
    this.dialog.open(this.amountInfoDialog, {
      width: '90%',
      maxWidth: '450px',
      autoFocus: false, // Prevents the button from being aggressively highlighted on open
    });
  }

  // Update onYearChange method
  onYearChange(): void {
    // Reset expanded panels when year changes
    this.expandedPanels = new Array(12).fill(false);
    this.prepareChartData();

    // Don't calculate here - wait for getAnnualTotal to complete
    // Just update the dynamic totals based on selected year
    this.calculateFollowingDynamicYearTotals(this.selectedYear);

    // If we already have taxableAmount, calculate incidence
    if (this.taxableAmount !== undefined && this.taxableAmount !== null) {
      this.calculateIncidence();
    }

    this.cdr.detectChanges(); // Trigger UI update
  }

  // Update calculateIncidence method with safety checks
  private calculateIncidence() {
    // Safety check for taxableAmount
    if (
      !this.taxableAmount ||
      this.taxableAmount === 0 ||
      isNaN(this.taxableAmount)
    ) {
      this.yearTaxIncidence = NaN;
      this.yearContributiIncidence = NaN;
    } else {
      // Calculate incidence dynamically
      this.yearTaxIncidence =
        (this.nextYearDynamicTotalAmountTasse / this.taxableAmount) * 100;
      this.yearContributiIncidence =
        (this.nextYearDynamicTotalAmountContributi / this.taxableAmount) * 100;
    }

    this.nextYearDynamicTotalAmountTasse = this.roundToTwoDecimals(
      this.nextYearDynamicTotalAmountTasse,
    );

    this.yearTaxIncidence = this.roundToTwoDecimals(this.yearTaxIncidence);
    this.yearContributiIncidence = this.roundToTwoDecimals(
      this.yearContributiIncidence,
    );
  }

  formatIncidence(value: number): string {
    return isNaN(value) ? '-' : value.toFixed(2) + '%';
  }

  // Get events for a specific month and year
  getMonthEvents(monthIndex: number, year: number): FiscalEventInterface[] {
    return this.allEvents.filter((event) => {
      const eventDate = new Date(event.date);
      return (
        eventDate.getMonth() === monthIndex && eventDate.getFullYear() === year
      );
    });
  }

  // Get total amount for a specific month and year
  getMonthTotal(monthIndex: number, year: number): number {
    const monthEvents = this.getMonthEvents(monthIndex, year);
    return monthEvents.reduce((total, event) => {
      if (event.is_credit === false) {
        return total + (Number(event.amount) || 0);
      } else {
        return total + (Number(event.amount) || 0);
      }
    }, 0);
  }

  // Check if panel should be expanded
  isPanelExpanded(monthIndex: number): boolean {
    return this.expandedPanels[monthIndex];
  }

  // Handle year selection change
  // onYearChange(): void {
  //   // Reset expanded panels when year changes
  //   this.expandedPanels = new Array(12).fill(false);
  //   this.prepareChartData();

  //   this.calculateFollowingDynamicYearTotals(this.selectedYear);
  //   console.log(
  //     this.selectedYear,
  //     '--',
  //     this.nextYearDynamicTotalAmountTasse,
  //     this.taxableAmount,
  //   );
  //   this.calculateIncidence();
  //   console.log(
  //     this.selectedYear,
  //     '--',
  //     this.nextYearDynamicTotalAmountTasse,
  //     this.taxableAmount,
  //   );

  //   this.cdr.detectChanges(); // Trigger UI update
  // }

  dayClicked({ day }: { day: CalendarMonthViewDay }): void {
    console.log('Clicked day', day.date);
    console.log('Events for this day', day.events);

    this.dialog.open(EventDetailsDialogComponent, {
      width: '450px',
      data: { day },
      panelClass: 'event-dialog-container',
    });
  }

  togglePaidStatus(fiscal_event: FiscalEventInterface) {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.fiscalEventService
      .updateFiscalEventDetails(organization_id, fiscal_event.id, {
        is_paid: fiscal_event.is_paid,
      })
      .subscribe({
        next: (updatedFiscalEvent: any) => {
          this.showSuccessMessage(
            `Evento ${fiscal_event.name} (di ${fiscal_event.amount}) aggiornato!`,
          );
        },
        error: (err: any) => {
          console.error('Error updating invoice:', err);
          // Revert the checkbox if the update fails
          fiscal_event.is_paid = !fiscal_event.is_paid;
          this.showErrorMessage('Errore. Riprova.');
        },
      });
  }

  softDeleteEvent(fiscal_event: FiscalEventInterface) {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.fiscalEventService
      .updateFiscalEventDetails(organization_id, fiscal_event.id, {
        is_deleted: true,
      })
      .subscribe({
        next: (updatedFiscalEvent: any) => {
          this.showSuccessMessage(
            `Evento ${fiscal_event.name} eliminato con successo!`,
          );

          this.cdr.detectChanges();
        },
        error: (err: any) => {
          console.error('Error updating invoice:', err);
          // Revert the checkbox if the update fails
          fiscal_event.is_paid = !fiscal_event.is_paid;
          this.showErrorMessage('Errore. Riprova.');
          this.cdr.detectChanges();
        },
      });

    this.loadEvents();
    this.cdr.detectChanges();
  }

  openEventeDetail(fiscalEvent: FiscalEventInterface): void {
    const organization = this.organization_data;
    const data: FiscalEventDetailData = { fiscalEvent, organization };

    this.eventSheet.open(FiscalEventDetailsComponent, {
      data,
      panelClass: 'fiscal-event-detail-bottom-sheet',
    });

    this.cdr.detectChanges();
  }

  openStatusInfoDialog() {
    const dialogRef = this.dialog.open(FiscalPlanHelpDialogComponent, {
      width: '90vw',
      maxWidth: '700px', // Slightly wider to accommodate the link
      height: '520px',
    });
  }

  getTaxRate(type: string | undefined): string {
    if (type === 'STARTUP') {
      return '5%';
    } else if (type === 'ALIQUOTA_15') {
      return '15%';
    }
    return 'N/A'; // Default fallback
  }

  // Navigation methods
  today(): Date {
    return new Date();
  }

  backToDashboard(): void {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/dashboard`]);
  }

  private showSuccessMessage(message: string): void {
    this.snackBar.open(message, 'Chiudi', {
      duration: 3000,
      panelClass: ['success-snackbar'],
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }

  private showErrorMessage(message: string): void {
    this.snackBar.open(message, 'Chiudi', {
      duration: 3000,
      panelClass: ['error-snackbar'],
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }
}
